export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 64;

export function evaluatePassword(password) {
    const value = password || "";

    return {
        length: value.length >= PASSWORD_MIN_LENGTH && value.length <= PASSWORD_MAX_LENGTH,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        special: /[^A-Za-z0-9\s]/.test(value),
        edgeSpaces: value.startsWith(" ") || value.endsWith(" ")
    };
}

export function isPasswordValid(password) {
    const result = evaluatePassword(password);

    return result.length &&
        result.uppercase &&
        result.lowercase &&
        result.number &&
        result.special;
}